/* Mitti & Mor: launch dates for coming-soon products.
 *
 * Reads #mm-launch-data (rendered by snippets/mm-launch-data.liquid) and:
 *  1. replaces "Sold out" badges on coming-soon products with "Launching 21 Oct";
 *  2. drops a typographic cover into product cards and product pages that have no image
 *     (on a product page with no images it adds the image column Drive leaves out);
 *  3. fills any element carrying data-mm-launch-pid with the launch label.
 *
 * Rolling rule (agreed 11 Oct 2026): if a product's stored launch date has passed
 * and it is still coming soon, show the next Wednesday after today (IST).
 * The stored date in custom.launch_date is never changed by this script.
 */
(function () {
  'use strict';
  var el = document.getElementById('mm-launch-data');
  var data = {};
  try { data = el ? JSON.parse(el.textContent) : {}; } catch (e) { data = {}; }
  var DAY = 864e5;

  function todayIST() {
    var s = new Date().toLocaleDateString('en-CA', { timeZone: 'Asia/Kolkata' });
    return new Date(s + 'T00:00:00Z');
  }

  function effectiveDate(iso) {
    if (!iso) return null;
    var t = new Date(iso + 'T00:00:00Z');
    if (isNaN(t)) return null;
    var today = todayIST();
    if (t >= today) return t;
    var add = (3 - today.getUTCDay() + 7) % 7; // 3 = Wednesday
    if (add === 0) add = 7;
    return new Date(today.getTime() + add * DAY);
  }

  var WD = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MO = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function fmt(t, long) {
    var s = t.getUTCDate() + ' ' + MO[t.getUTCMonth()];
    return long ? WD[t.getUTCDay()] + ' ' + s : s;
  }

  function info(pid) {
    var r = data[pid];
    if (!r) return null;
    var t = effectiveDate(r.d);
    if (!t) return { label: 'Coming soon', short: 'Coming soon', date: null, days: null };
    var days = Math.round((t - todayIST()) / DAY);
    if (days === 0) return { label: 'Launching today', short: 'Launching today', date: t, days: 0 };
    return { label: 'Launching ' + fmt(t, true), short: 'Launching ' + fmt(t), date: t, days: days };
  }

  function cover(pid) {
    var tpl = document.getElementById('mm-covers');
    if (!tpl) return null;
    var c = tpl.content.querySelector('[data-pid="' + pid + '"]');
    if (!c) return null;
    c = c.cloneNode(true);
    fillDates(c);
    return c;
  }

  function fillDates(root) {
    root.querySelectorAll('[data-mm-launch-pid]').forEach(function (e) {
      var i = info(e.getAttribute('data-mm-launch-pid'));
      if (!i) return;
      var mode = e.getAttribute('data-mm-launch-format');
      e.textContent = mode === 'short' ? i.short.replace('Launching ', '')
        : mode === 'date' ? (i.days === 0 ? 'Today' : i.date ? fmt(i.date, true) : 'Soon')
        : mode === 'countdown' ? (i.days === 0 ? 'Launching today' : i.days === 1 ? 'Launching tomorrow' : 'Launching in ' + i.days + ' days')
        : i.label;
    });
  }

  function apply(root) {
    if (!root || !root.querySelectorAll) return;

    root.querySelectorAll('.product-badges__badge').forEach(function (b) {
      if (b.dataset.mmDone) return;
      b.dataset.mmDone = '1';
      var host = b.closest('[data-product-id]');
      var pid = host ? host.getAttribute('data-product-id') : window.mmPid;
      var i = pid && info(pid);
      if (i) { b.textContent = i.short; b.classList.add('mm-launch-badge'); }
    });

    root.querySelectorAll('.card-gallery[data-product-id]').forEach(function (g) {
      if (g.dataset.mmCover) return;
      g.dataset.mmCover = '1';
      var pid = g.getAttribute('data-product-id');
      if (!data[pid] || g.querySelector('img')) return;
      var c = cover(pid);
      if (!c) return;
      var frame = document.createElement('span');
      frame.className = 'mm-cover-frame';
      frame.appendChild(c);
      var ph = g.querySelector('.product-card-gallery__title-placeholder');
      if (ph) ph.replaceWith(frame); else g.prepend(frame);
    });

    fillDates(root);
  }

  function productPage() {
    var pid = window.mmPid;
    if (!pid || !data[pid]) return;
    // Drive collapses to one centred column when a product has no images.
    // Until real photos are uploaded, stand the cover in as the image column.
    var grid = document.querySelector('.product-information--media-none');
    if (grid && !grid.querySelector('.mm-cs-media')) {
      var c = cover(pid);
      if (!c) return;
      var col = document.createElement('div');
      col.className = 'product-information__media mm-cs-media';
      var frame = document.createElement('div');
      frame.className = 'mm-cover-frame mm-cover-frame--pdp';
      frame.appendChild(c);
      col.appendChild(frame);
      grid.classList.remove('product-information--media-none');
      grid.classList.add('product-information--media-left');
      grid.prepend(col);
      return;
    }
    var mg = document.querySelector('media-gallery');
    if (mg && !mg.querySelector('img') && !mg.querySelector('.mm-cover')) {
      var c2 = cover(pid);
      if (c2) {
        var f2 = document.createElement('div');
        f2.className = 'mm-cover-frame mm-cover-frame--pdp';
        f2.appendChild(c2);
        mg.prepend(f2);
      }
    }
  }

  window.MMLaunch = { info: info, effectiveDate: effectiveDate, todayIST: todayIST, data: data, cover: cover, apply: apply };

  function run() {
    apply(document);
    productPage();
    document.documentElement.classList.add('mm-launch-ready');
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) { if (n.nodeType === 1) apply(n.parentNode || n); });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  // Never leave badges hidden if something above throws.
  setTimeout(function () { document.documentElement.classList.add('mm-launch-ready'); }, 2500);
})();
